class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.links_open = this.querySelectorAll("[data-open-mega-menu]");
    this.header = document.querySelector(".header");
    this.closeButton = this.querySelector(".mega-menu__close");
    this.headerHeight = this.header.offsetHeight;
    this.simpleLinks = this.querySelectorAll(
      ".mega-menu__container .mega-menu__link:not([data-open-mega-menu])"
    );

    this.links_open.forEach((link) => {
      link.addEventListener("mouseover", (e) => {
        e.preventDefault();
        let event = e;
        // Check if mouse stay 1 second on hover on link
        setTimeout(
          function (e) {
            if (link.matches(":hover")) {
              this.toggleMenu(link);
            }
          }.bind(this),
          350
        );
      });
    });

    this.links_open.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });

    this.links_open.forEach((link) => {
      link.addEventListener("toggle", (e) => {
        e.preventDefault();
        this.toggleMenu2(e);
      });
    });

    this.simpleLinks = this.querySelectorAll(
      ".mega-menu__container .mega-menu__link:not([data-open-mega-menu])"
    );

    this.simpleLinks.forEach((link) => {
      link.addEventListener("mouseover", (e) => {
        this.querySelectorAll(".link").forEach((link) => {
          link.classList.remove("active");
        });

        this.querySelectorAll(".mega-menu__panel").forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });

        this.header.classList.remove("header--active");
      });
    });

    document
      .querySelector("#section-w-header")
      .addEventListener("mouseleave", () => {
        this.closeMenu();
      });

    if (window.innerWidth >= 990) {
      this.header.addEventListener("mouseenter", () => {
        this.header.classList.add("header--hover");
        document.querySelector("body").classList.add("shadow");
      });

      this.header.addEventListener("mouseleave", () => {
        this.header.classList.remove("header--hover");
        if (
          !document.querySelector(".header--active") &&
          !document.querySelector("side-cart").classList.contains("open")
        ) {
          document.querySelector("body").classList.remove("shadow");
        }
      });
    }

    this.closeButton.addEventListener("click", () => this.closeMenu());

    this.swiper = [];
    this.querySelectorAll(".header .swiper").forEach((element) =>
      this.initSwiper(element)
    );

    setTimeout(() => {
      console.log(this.header.querySelectorAll(".swiper-button-lock"));
      this.header.querySelectorAll(".swiper-button-lock").forEach((element) => {
        element
          .closest("[data-mega-menu]")
          .querySelector(".swiper-wrapper").style.justifyContent = "center";
      });
    }, 1000);

    this.updateHeaderPosition();
    window.addEventListener("scroll", () => {
      this.updateHeaderPosition();
    });
  }

  toggleMenu(link) {
    let currentLink = link.currentTarget ? link.currentTarget : link;

    let is_main_menu = currentLink.classList.contains("mega-menu__link--main");

    if (this.querySelector(".mega-menu__link--main.active") && is_main_menu) {
      this.querySelector(".mega-menu__link--main.active").dispatchEvent(
        new Event("toggle")
      );
    }

    let menu = currentLink.getAttribute("data-open-mega-menu");
    let menuElement = document.querySelector(`[data-mega-menu="${menu}"]`);
    let parentMenu = document.querySelector(`[data-parent-menu="${menu}"]`);
    let is_open = currentLink.classList.contains("active");

    let panelSecondOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;
    let panelFirstOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;

    if (panelSecondOpen) {
      document
        .querySelectorAll(".mega-menu__panel--second.mega-menu__panel--actif")
        .forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });
    }

    if (panelFirstOpen) {
      document
        .querySelectorAll(
          ".mega-menu__panel--first.mega-menu__panel--actif .link"
        )
        .forEach((panel) => {
          panel.classList.remove("active");
        });
    }

    if (currentLink.classList.contains("active")) {
      currentLink.classList.remove("active");
    } else {
      currentLink.classList.add("active");
    }

    if (menuElement.classList.contains("mega-menu__panel--actif")) {
      menuElement.classList.remove("mega-menu__panel--actif");
      menuElement.querySelectorAll(".link").forEach((link) => {
        link.classList.remove("active");
      });

      parentMenu.classList.remove("mega-menu__panel--actif");
      parentMenu.querySelectorAll(".link").forEach((link) => {
        link.classList.remove("active");
      });
    } else {
      menuElement.classList.add("mega-menu__panel--actif");
    }

    if (this.querySelectorAll(".link.active").length > 0) {
      this.header.classList.add("header--active");
      document.querySelector("body").classList.add("shadow");
    } else {
      this.header.classList.remove("header--active");
      document.querySelector("body").classList.remove("shadow");
    }

    if (is_main_menu && menuElement.querySelector("li [data-open-mega-menu]")) {
      menuElement
        .querySelector("li [data-open-mega-menu]")
        .dispatchEvent(new Event("toggle"));
    }
  }

  toggleMenu2(link) {
    let currentLink = link.currentTarget;

    let menu = currentLink.getAttribute("data-open-mega-menu");
    let menuElement = document.querySelector(`[data-mega-menu="${menu}"]`);
    let parentMenu = document.querySelector(`[data-parent-menu="${menu}"]`);
    let is_open = currentLink.classList.contains("active");
    let panelSecondOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;
    let panelFirstOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;

    if (panelSecondOpen) {
      document
        .querySelectorAll(".mega-menu__panel--second.mega-menu__panel--actif")
        .forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });
    }

    if (panelFirstOpen) {
      document
        .querySelectorAll(
          ".mega-menu__panel--first.mega-menu__panel--actif .link"
        )
        .forEach((panel) => {
          panel.classList.remove("active");
        });
    }

    if (currentLink.classList.contains("active")) {
      currentLink.classList.remove("active");
    } else {
      currentLink.classList.add("active");
    }

    if (menuElement.classList.contains("mega-menu__panel--actif")) {
      menuElement.classList.remove("mega-menu__panel--actif");
      menuElement.querySelectorAll(".link").forEach((link) => {
        link.classList.remove("active");
      });

      parentMenu.classList.remove("mega-menu__panel--actif");
      parentMenu.querySelectorAll(".link").forEach((link) => {
        link.classList.remove("active");
      });
    } else {
      menuElement.classList.add("mega-menu__panel--actif");
    }

    if (this.querySelectorAll(".link.active").length > 0) {
      this.header.classList.add("header--active");
      document.querySelector("body").classList.add("shadow");
    } else {
      this.header.classList.remove("header--active");
      document.querySelector("body").classList.remove("shadow");
    }
  }

  closeMenu() {
    this.querySelectorAll(".link").forEach((link) => {
      link.classList.remove("active");
    });

    this.querySelectorAll(".mega-menu__panel").forEach((panel) => {
      panel.classList.remove("mega-menu__panel--actif");
    });

    this.header.classList.remove("header--active");
    document.querySelector("body").classList.remove("shadow");
  }

  initSwiper(element) {
    if (element.querySelectorAll(".mega-menu__item").length > 5) {
      element.closest("[data-mega-menu]").classList.add("swiper-loaded");
      this.swiper.push(
        new Swiper(element, {
          slidesPerView: "auto",
          spaceBetween: 16,
          freeMode: true,
          navigation: {
            nextEl: element
              .closest("[data-mega-menu]")
              .querySelector(".swiper-button-next"),
            prevEl: element
              .closest("[data-mega-menu]")
              .querySelector(".swiper-button-prev"),
          },
        })
      );
    }
  }

  updateHeaderPosition() {
    if (window.scrollY > 300 && window.innerWidth >= 990) {
      this.header.classList.add("header--scrolled");
      document.querySelector("body").style.paddingTop =
        this.headerHeight + "px";
      document.querySelector("body").classList.add("on-scroll");
      document
        .querySelector("#section-w-header")
        .classList.add("section-header-scrolled");
    } else {
      document.querySelector("body").style.paddingTop = 0;
      document.querySelector("body").classList.remove("on-scroll");
      this.header.classList.remove("header--scrolled");
      document
        .querySelector("#section-w-header")
        .classList.remove("section-header-scrolled");
    }
  }
}

customElements.define("mega-menu", MegaMenu);

class DrawerMenu extends HTMLElement {
  constructor() {
    super();

    this.openButton = document.querySelector(".open-drawer-menu");
    this.closeButton = this.querySelector(".drawer-menu__close");
    this.categoryButtons = this.querySelectorAll("[data-toggle-category]");
    this.subcategoryButtons = this.querySelectorAll("[data-toggle-subcategory]");

    this.openButton.addEventListener("click", () => this.openMenu());
    this.closeButton.addEventListener("click", () => this.closeMenu());

    this.categoryButtons.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.toggleCategory(event.currentTarget);
      });
    });

    this.subcategoryButtons.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.toggleSubcategory(event.currentTarget);
      });
    });
  }

  openMenu() {
    this.classList.add("open");
    document.querySelector("body").classList.add("shadow-drawer");
  }

  closeMenu() {
    this.classList.remove("open");
    document.querySelector("body").classList.remove("shadow-drawer");

    this.querySelectorAll(".drawer-menu__subcategories").forEach((sub) => {
      sub.classList.remove("open");
    });
    this.querySelectorAll(".drawer-menu__products").forEach((products) => {
      products.classList.remove("open");
    });
    this.categoryButtons.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
      btn.classList.remove("active");
    });
    this.subcategoryButtons.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
      btn.classList.remove("active");
    });
  }

  toggleCategory(button) {
    const categoryName = button.getAttribute("data-toggle-category");
    const subcategoriesPanel = this.querySelector(
      `.drawer-menu__subcategories[data-category="${categoryName}"]`
    );
    const isOpen = button.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      button.setAttribute("aria-expanded", "false");
      button.classList.remove("active");
      subcategoriesPanel.classList.remove("open");

      subcategoriesPanel.querySelectorAll(".drawer-menu__products").forEach((products) => {
        products.classList.remove("open");
      });
      subcategoriesPanel.querySelectorAll("[data-toggle-subcategory]").forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
        btn.classList.remove("active");
      });
    } else {
      button.setAttribute("aria-expanded", "true");
      button.classList.add("active");
      subcategoriesPanel.classList.add("open");
    }
  }

  toggleSubcategory(button) {
    const subcategoryName = button.getAttribute("data-toggle-subcategory");
    const productsPanel = this.querySelector(
      `.drawer-menu__products[data-subcategory="${subcategoryName}"]`
    );
    const isOpen = button.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      button.setAttribute("aria-expanded", "false");
      button.classList.remove("active");
      productsPanel.classList.remove("open");
    } else {
      button.setAttribute("aria-expanded", "true");
      button.classList.add("active");
      productsPanel.classList.add("open");
    }
  }
}

customElements.define("drawer-menu", DrawerMenu);
